document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    var swiperTopContent = document.querySelectorAll('.top-content');
    if(swiperTopContent){
        swiperTopContent.forEach((item)=>{
            var swiperTopContent = new Swiper('.swiperTopContent', {
                /*Optional parameters*/
                slidesPerView: 1,
                speed: 600,
                effect: "fade",
                loop: true,
                pagination: {
                    el: ".swiperTopContent-pagination",
                    clickable: true
                },
                fadeEffect: {
                    "crossFade": true
                }
            });
        });
    };

    var swiperReviews = document.querySelectorAll('.reviews');
    if(swiperReviews){
        swiperReviews.forEach((item)=>{
            var swiperReview = new Swiper('.reviews__swiper', {
                /*Optional parameters*/
                slidesPerView: 1,
                speed: 800,
                autoHeight: true,
                spaceBetween: 0,
                loop: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: ".swiper-reviews-next",
                    prevEl: ".swiper-reviews-prev",
                }
            });
        });
    };

    var swiperReviews = document.querySelectorAll('.reviews-tag');
    if(swiperReviews){
        swiperReviews.forEach((item)=>{
            var swiperReview = new Swiper('.reviews-tag__swiper', {
                /*Optional parameters*/
                slidesPerView: 1,
                speed: 800,
                autoHeight: true,
                spaceBetween: 0,
                loop: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: ".swiper-reviews-next",
                    prevEl: ".swiper-reviews-prev",
                }
            });
        });
    };

    var swiperMenusCarousel = document.querySelectorAll('.menu-quad');
    if(swiperMenusCarousel){
        swiperMenusCarousel.forEach((item)=>{
            var eachMenu = new Swiper('.menu-quad__carousel--big', {
                /*Optional parameters*/
                slidesPerView: 1,
                speed: 800,
                spaceBetween: 0,
                loop: false,
                rewind: true,
                allowTouchMove: false,
                navigation: {
                    prevEl: ".swiper-menu-quad-prev",
                    nextEl: ".swiper-menu-quad-next"
                },
            });
            var eachMenuSmalls = new Swiper('.menu-quad__carousel--small', {
                /*Optional parameters*/
                slidesPerView: 2,
                speed: 800,
                spaceBetween: 8,
                loop: false, 
                rewind: true,
                allowTouchMove: false
            });

           
            let menuTagTabs = document.querySelectorAll('#menusFiltersList .js-menu-tab');
            let menuArrows = document.querySelectorAll('.menu-quad .swiper-arrow');
		
			menuTagTabs.forEach(tab => {			
				tab.addEventListener('click', (function() {
                    let tabParentLi = tab.parentElement;
                    let liIndex = tabParentLi.getAttribute('data-index');

                    eachMenu.slideTo(liIndex);
                    eachMenuSmalls.slideTo(liIndex);
                }));
			});

            menuArrows.forEach(arrow => {	
                arrow.addEventListener('click', (function() {
                    let menuTagTabs = document.querySelectorAll('#menusFiltersList li');                    
                    let menuImage = document.querySelector('.menu-quad .menu-tab-figure.swiper-slide-active');
                    let imageIndex = menuImage.getAttribute('data-index');

                    let indexedTab = menuTagTabs[imageIndex].querySelector('a');
                    indexedTab.click();
                }));
            });
        });
    };
    
    var swiperSlider = document.querySelectorAll('.slider-block');
    if(swiperSlider){
        swiperSlider.forEach((item)=>{
            var swiperReview = new Swiper('.swiperSlider', {
                /*Optional parameters*/
                slidesPerView: 1,
                speed: 700,
                effect: "fade",
                loop: true,
                fadeEffect: {
                    "crossFade": true
                },
                allowTouchMove: true,
                navigation: {
                    nextEl: ".swiper-slider-next"
                },
            });
        });
    };
    
    var swiperGallery = document.querySelectorAll('.gallery-block');
    if(swiperGallery){
        swiperGallery.forEach((item)=>{
            var swiperGallery = new Swiper('.gallery-block__swiper', {
                /*Optional parameters*/
                allowTouchMove: false,
                slidesPerView: 1,
                effect: "fade",
                loop: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".swiper-gallery-next",
                    prevEl: ".swiper-gallery-prev",
                },
            });
            var swiperGalleryMobile = new Swiper('.gallery-block__swiperMobile', {
                /*Optional parameters*/
                allowTouchMove: false,
                slidesPerView: 1,
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".swiper-gallery-next",
                    prevEl: ".swiper-gallery-prev",
                },
            });
        });
    };

     
    var swiperEvents = document.querySelectorAll('.events-block');
    if(swiperEvents){
        swiperEvents.forEach((item)=>{
            var swiperEventsOne = new Swiper('.swiperEventsImagesOne', {
                /*Optional parameters*/
                allowTouchMove: false,
                slidesPerView: 1,
                speed: 700,
                loop: true,
                navigation: {
                    nextEl: ".swiper-events-next",
                    prevEl: ".swiper-events-prev",
                },
            });
            var swiperEventsTwo = new Swiper('.swiperEventsImagesTwo', {
                /*Optional parameters*/
                allowTouchMove: false,
                slidesPerView: 1,
                speed: 700,
                loop: true,
                navigation: {
                    nextEl: ".swiper-events-next",
                    prevEl: ".swiper-events-prev",
                },
            });
            var swiperEventsThree = new Swiper('.swiperEventsImagesThree', {
                /*Optional parameters*/
                allowTouchMove: false,
                slidesPerView: 2,
                spaceBetween: 45,
                speed: 700,
                loop: true,
                navigation: {
                    nextEl: ".swiper-events-next",
                    prevEl: ".swiper-events-prev",
                },
            });

            var swiperEventsContent = new Swiper('.swiperEventsContent', {
                /*Optional parameters*/
                allowTouchMove: false,
                slidesPerView: 1,
                effect: "fade",
                speed: 700,
                loop: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".swiper-events-next",
                    prevEl: ".swiper-events-prev",
                },
            });
            var swiperEventsMobile = new Swiper('.swiperEventsMobile', {
                /*Optional parameters*/
                allowTouchMove: false,
                slidesPerView: 1,
                effect: "fade",
                speed: 700,
                loop: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".swiper-events-next",
                    prevEl: ".swiper-events-prev",
                },
            });
        });
    };
});